import { useRouteError, ErrorResponse } from "react-router";
import ErrorDisplay, { Props } from "@/components/ErrorDisplay";
import { Container } from "@/components/Container";

export default function ErrorPage({ status, statusText, ...rest }: Props) {
  const error = useRouteError() as ErrorResponse | undefined;
  return (
    <Container>
      <ErrorDisplay
        status={status ?? error?.status}
        statusText={statusText ?? error?.statusText}
        {...rest}
      />
    </Container>
  );
}
